"use client"

import axios from "axios"
import { useEffect, useState } from "react"
import { NotificationManager } from "react-notifications"
import SearchDropdown from "../../../components/Dropdowns/SearchDropdown"
import OptionalOption from "../../../components/FilterComponents/OptionalOption"
import useAuth from "../../../hooks/useAuth"
import { BASE_URL } from "../../../utils/Element"

const ContractCloseFilterData = ({ filterData, onSetFilterData , from}) => {
  const [config] = useAuth()
  const [isSidebarOpen, setIsSidebarOpen] = useState(true) // Set to true for testing
  const [currentPhaseOptions, setCurrentPhaseOptions] = useState([])
  const [nextActionOptions, setNextActionOptions] = useState([])
 const [phaseValue, setPhaseValue] = useState([])
  const fetchContractSuggestions = async (inputValue, fieldType) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/get-datalisting?list=contract_to_close&search=${inputValue}&field=${fieldType}`,
        config,
      )

      const contractData = response?.data?.contract_to_close || {}
      const options = Object.entries(contractData).map(([key, value]) => ({
        label: value,
        value: key,
      }))

      if (fieldType === "current_phase") {
        setCurrentPhaseOptions(options)
      } else if (fieldType === "next_action") {
        setNextActionOptions(options)
      }
    } catch (err) {
      console.error(`Error fetching ${fieldType} suggestions:`, err) // Debug log
      if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
        NotificationManager.error(err.response?.data?.message)
      }
    }
  }

  useEffect(() => {
    if (isSidebarOpen) {
      Promise.all([
        fetchContractSuggestions("", "current_phase"),
        fetchContractSuggestions("", "next_action"),
      ]).catch((err) => {
        console.error("Error fetching contract suggestions:", err)
      })
    }
  }, [isSidebarOpen])

  const handleSelect = (option, fieldName) => {
    console.log(`handleSelect triggered for ${fieldName}:`, option) // Debug log
    if (option) {
      console.log(`Updating filterData with ${fieldName}:`, option.value) // Debug log
      onSetFilterData({
        ...filterData,
        [fieldName]: option.value,
      });
      setPhaseValue({
        ...filterData,
        [fieldName]: option.label,
      });
    }
  }

   if (from === "contractclosearchive") {
      return (
        <div>
          <p className="head-4 dark-H">Date Range</p>
  
          <OptionalOption
            activeTab="date"
            onSetLastDate={(value) => onSetFilterData({ ...filterData, count: value })}
            date={filterData?.count}
            onSetDateRange1={(value) =>
              onSetFilterData({ ...filterData, start_count: value })
            }
            date2={filterData?.start_count}
            onSetDateRange2={(value) =>
              onSetFilterData({ ...filterData, end_count: value })
            }
            date3={filterData?.end_count}
            onClear={() => {
              onSetFilterData({
                ...filterData,
                count: "",
                start_count: "",
                end_count: "",
              });
            }}
          />
        </div>
      );
    }

  return (
    <>
      <div className="mt-4">
        <label className="dark-H head-4 mb-2">Current Phase</label>
        <SearchDropdown
          className="body-N"
          name="current_phase"
          type="text"
          text={phaseValue?.current_phase}
          placeholder="Write Current Phase Here"
          options={currentPhaseOptions}
          fetchSuggestions={(inputValue) => fetchContractSuggestions(inputValue, "current_phase")}
          onSetOptions={(value) => setCurrentPhaseOptions(value)}
          handleSelect={(option) => handleSelect(option, "current_phase")} 
        />
      </div>

      <div className="mt-4">
        <label className="dark-H head-4 mb-2">Next Action</label>
        <SearchDropdown
          className="body-N"
          name="next_action"
          type="text"
          text={phaseValue?.next_action}
          placeholder="Write Next Action Here"
          options={nextActionOptions}
          fetchSuggestions={(inputValue) => fetchContractSuggestions(inputValue, "next_action")}
          onSetOptions={(value) => setNextActionOptions(value)}
          handleSelect={(option) => handleSelect(option, "next_action")} 
        />
      </div>
      
    </>
  )
}

export default ContractCloseFilterData;
